
<div class="discuss-body">
<div class="modal-content">
    <!-- HEADER Of POPUP STARTS -->
    <div class="modal-header" id="create-discuss-modal-header">
      <div style="display: flex; width: 100%;">
        <div class="col-10 col-lg-10">
          <h5 class="modal-title" title="add-discussion">Create a Post</h5>
        </div>
        <div class="col-2 col-lg-2">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>

    <!-- BODY Of POPUP STARTS -->
    <div class="modal-body">
        <div class="modal-info" id="create-discuss-modal-body">
            <div class="post-type-tabs">
                <div class="row">
                    <div class="col-lg-6">
                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a class="nav-link active" id="pills-newpost-tab" data-toggle="pill" href="#pills-newpost" role="tab" aria-controls="pills-newpost" aria-selected="true"  (click)="tabChangePostMCQ('simple')">
                                    <div class="new-post-icon mr-2"></div> New Post</a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link" id="pills-mcq-tab" data-toggle="pill" href="#pills-mcq" role="tab" aria-controls="pills-mcq" aria-selected="false" (click)="tabChangePostMCQ('mcq')">
                                    <div class="mcq-post-icon mr-2" ></div> Post an MCQ</a>
                            </li>
                        </ul>
                    </div>
                    <!-- <div class="col-lg-6 mb-lg-0 mb-3">
                        <div class="coin-count d-flex align-items-center nowrap">
                            <div class="available-coins"><img src="assets/images/point-coin.png" alt="coin" class="mr-2"> You have 290 points</div>
                            <div class="use-coin">
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button type="button" class="btn btn-default btn-number" disabled="disabled" data-type="minus" data-field="quant[1]">
                                            <img src="assets/images/minus-black.svg" class="minus-icon" alt="">
                                        </button>
                                    </span>
                                    <input type="text" name="quant[1]" class="form-control input-number" value="25">
                                    <span class="input-group-btn">
                                        <button type="button" class="btn btn-default btn-number" data-type="plus" data-field="quant[1]">
                                            <img src="assets/images/add.svg" alt="" class="add-icon">
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-newpost" role="tabpanel" aria-labelledby="pills-newpost-tab">
                        <div class="add-post-inputbox">
                          <div [formGroup]="section1_form">
                            <div class="form-group">
                              <input type="text" class="form-control post-title" formControlName="postTitle" rows="1" maxlength='50' placeholder="Enter the Title upto 50 Characters.">
                              <span class="text-danger" *ngIf="section1_form.controls['postTitle'].hasError('required') && (section1_form.controls['postTitle'].dirty || section1_form.controls['postTitle'].touched)">Title is required</span>
                            </div>
                            <!-- <input type="text" class="form-control post-title" rows="1" placeholder="Please add Title here" [(ngModel)]="postTitle">
                            <div *ngIf="section1Submit && postTitle == ''" class="invalid-feedback">
                              <div >Title is required</div>
                            </div> -->
                            <!-- <br> -->
                            <div class="form-group">
                              <textarea placeholder="Enter the Description" formControlName="postDescription" class="form-control" rows="10"></textarea>
                              <span class="text-danger" *ngIf="section1_form.controls['postDescription'].hasError('required') && (section1_form.controls['postDescription'].dirty || section1_form.controls['postDescription'].touched)">Description is required</span>
                            </div>
                          </div>



                            <div class="row mt-3">
                                <div class="col-md-8">
                                    <ul class="list-inline  mb-0 d-flex align-items-center h-100">
                                        <li class="list-inline-item">
                                            <input type="file" (change)="fileChangeEventUpload($event.target.files)" style="display:none;" #fileUpload>
                                            <div class="text-dark" style="cursor: pointer;" (click)="fileUpload.click()">
                                              <img src="assets/images/attachment-icon.svg" alt="attachment" class="mr-2">
                                              Attach Photo
                                            </div>

                                            <div *ngIf="fileName" class="outer-file">
                                              <div *ngIf="imageSrc" style="width: 50px; height: 50px;" class="mr-3">
                                                <img [src]="imageSrc" style="object-fit: contain; width: 100%; height: 100%;">
                                              </div>
                                              <div class="upload-file-name">{{fileName}}</div>
                                             <div class="remove-icon"><i class="fa fa-remove" style="font-size:24px;color:red" (click)="removeFile()"></i></div>
                                            </div>
                                            <div *ngIf="showSupportText">
                                              <span class="text-warning">{{supportText}}</span>
                                            </div>
                                        </li>
                                        <!-- <li class="list-inline-item">
                                            <a href="#" class="text-dark"><img src="assets/images/scan-doc-icon.svg" alt="attachment" class="mr-2"> Scan Document</a>
                                        </li> -->
                                    </ul>
                                </div>
                                <div class="col-md-4 text-right">
                                    <button class="btn btn-pink-gradiant btn-next" data-dismiss="modal" data-toggle="modal" data-target="#select-exam-post" (click)="open('section2')">Next</button>
                                </div>
                                <!-- <div class="row mt-3">
                                  <div class="col-12 text-right">
                                    <button class="btn btn-pink-gradiant btn-next" data-dismiss="modal" data-toggle="modal" data-target="#select-exam-post" (click)="open('section2')">Next</button>
                                  </div>
                              </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="pills-mcq" role="tabpanel" aria-labelledby="pills-mcq-tab">
                        <div class="add-post-inputbox">
                          <div [formGroup]="section2_form">
                            <div class="form-group">
                              <input type="text" class="form-control post-title" formControlName="postTitle" rows="1" placeholder="Enter the Title upto 50 Characters.">
                              <span class="text-danger" *ngIf="section2_form.controls['postTitle'].hasError('required') && (section2_form.controls['postTitle'].dirty || section2_form.controls['postTitle'].touched)">Title is required</span>
                            </div>
                          </div>
                            <textarea placeholder="Enter Question Text" class="form-control" rows="5" [(ngModel)]="postQuestion"></textarea>

                            <!--  -->
                            <!-- <form [formGroup]="demoForm"></form>
                            <div class="col-12 col-sm-6 col-md-4" formArrayName="resultsArray" *ngFor="let arrayItem of arrayItems; let i=index">
                                <div class="custom-control custom-radio">
                                    <input class="custom-control-input" id="radio_options_{{i}}" type="radio" formControlName="{{i}}" value="{{arrayItem.title}}">
                                    <label for="radio_options_{{i}}" class="custom-control-label"> {{arrayItem.title}} </label>
                                </div>
                            </div>

                            <button class="btn btn-pink-gradiant btn-next" name="Add More" (click)='addItem()'>Add More</button>
                            <button class="btn btn-pink-gradiant btn-next" name="Remove Extra" (click)='removeItem()'>Remoe Extra</button>
                         </form> -->
                            <!--  -->

                            <form [formGroup]="mcqForm">
                                <div class="row mt-3">
                                    <div class="col-12" formArrayName="answerReturnArray" *ngFor="let arrayItem of answerReturnArray.controls; let i=index">
                                        <div class="mcq-option d-flex">
                                            <span class="option-list mr-3">{{i+1}}</span>
                                            <span class="option-answer">
                                            <input type="text" id="answer_text_id_{{i+1}}"  class="form-control" formControlName="{{i}}" value="{{arrayItem.title}}"
                                               placeholder="Option {{i+1}}">
                                        </span>
                                        </div>
                                    </div>
                                    <!-- <div class="col-12">
                                    <div class="mcq-option d-flex">
                                        <span class="option-list mr-3">B</span>
                                        <span class="option-answer"><input type="text" class="form-control" placeholder="Option 2"></span>
                                    </div>
                                </div> -->
                                    <div class="col-sm-12 text-center more-options">
                                      <span class="minus-btn"><button class="btn btn-link btn-more-options" (click)='removeItem()'>-</button></span>
                                      <span class="option-text">Option</span>
                                      <span class="add-btn"> <button class="btn btn-link btn-more-options" (click)='addItem()'>+</button></span>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                  <div class="alert alert-danger" id="option-error-msg" style="display:none;">
                                    You can't add more than 5 <strong>options!</strong>
                                 </div>
                                 <div class="alert alert-danger" id="option-error-empty-msg" style="display:none;">
                                  Options are already <strong>empty!</strong>
                               </div>
                                </div>
                                <div class="col-sm-12">
                                  <div class="correct-option">
                                    <div>Choose Correct option :</div>
                                    <button class="btn option_radio_id_default" [ngClass]="0 == selectedOption ? 'selected-option':''"  (click)="optionClicked(0)">Don't know</button>
                                    <span formArrayName="optionReturnArray" *ngFor="let optArrayItem of optionReturnArray.controls; let j=index">
                                      <button class="btn option_radio_id" id="option_radio_id_{{j+1}}" [ngClass]="j+1 == selectedOption ? 'selected-option':''" (click)="optionClicked(j+1)" >{{j+1}}</button>
                                  </span>
                                </div>
                                    <!-- <div formArrayName="optionReturnArray" *ngFor="let optArrayItem of optionReturnArray.controls; let j=index">
                                        <div class="correct-option">
                                            <p>Correct-option</p>
                                            <button class="btn btn-dontknow" id="option_radio_id_10">Don't know</button>
                                            <input type="radio" class="btn btn-option" id="option_radio_id_{{j+1}}" formControlName="{{j}}" value="{{optArrayItem.optionTitle}}">
                                        </div>
                                    </div> -->
                                </div>
                            </form>
                            <div class="row mt-3">
                                <div class="col-12 text-right">
                                    <button class="btn btn-pink-gradiant btn-next" data-dismiss="modal" data-toggle="modal" (click)="open('section2')" data-target="#select-exam-post">Next</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<div class="modal-content">
    <div class="modal-header" id="create-exam-modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
        <h5 class="modal-title" title="select-exam">Select Exam</h5>
    </div>
    <div class="modal-body">
        <div class="modal-info" id="create-exam-modal-body">
            <div class="search-header mb-3">
                <div class="input-group">
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary ml-0" type="button" id="button-addon2"><img src="assets/images/search.svg" alt="search"></button>
                    </div>
                    <input type="text" class="form-control" [formControl]="examSearchCtrl" (keyup)="applyFilterExam($event)" placeholder="Search Exams, Posts or Classmates" aria-label="Recipient's username" aria-describedby="button-addon2">
                </div>
            </div>
            <div class="exam-type-tabs">
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <a class="nav-link active" id="pills-allexams-tab" data-toggle="pill" href="#pills-allexams" role="tab" aria-controls="pills-allexams" aria-selected="true" (click)="setExamMainCat('0')"> All Exams</a>
                    </li>
                    <li class="nav-item" role="presentation" *ngFor="let exam of examData">
                        <a class="nav-link" id="{{exam.main_cat_slug}}-tab" data-toggle="pill" href="#{{exam.main_cat_slug}}" role="tab" aria-controls="pills-railwayexam" aria-selected="false" (click)="setExamMainCat(exam.main_cat_id)" > {{exam.main_cat_title}}</a>
                    </li>

                </ul>
                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-allexams" role="tabpanel" aria-labelledby="pills-allexams-tab">
                        <div class="exam-post-inputbox">
                            <div class="row mb-4" *ngFor="let exam of filterExamData">
                                <div class="col-12">
                                    <div class="heading-exam">
                                        <h4>{{exam.main_cat_title}}</h4>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6 col-md-4" *ngFor="let subExam of exam.sub_category; let i=index">
                                    <div class="custom-control custom-radio" data-toggle="tooltip" title="{{subExam.category_name}}">
                                        <input type="checkbox" id="checkbox_exam_{{subExam.category_name}}_{{i}}" class="custom-control-input" [(ngModel)]="subExam.isChecked" value="{{subExam.id}}">
                                        <label class="custom-control-label custom-ellipses" for="checkbox_exam_{{subExam.category_name}}_{{i}}"><img width="32" src="{{discussUrl}}{{subExam.cat_image}}" alt="" class="mr-2"> {{subExam.category_name}}</label>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="alert alert-danger cust-err-msg" id="error-msg-exam" style="display:none;">
                          Please select atleast one <strong>Exam!</strong>
                       </div>
                        <div class="row mt-3">
                            <div class="col-12 text-right">
                                <button class="btn btn-previous mr-2" data-dismiss="modal" data-target="#create-post" (click)="open('section1')" data-toggle="modal">Previous</button>
                                <button class="btn btn-pink-gradiant btn-next" data-dismiss="modal" data-target="#select-subject-post" (click)="open('section3')" data-toggle="modal">Next</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-content">
    <div class="modal-header" id="create-subject-modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h5 class="modal-title" title="select-exam">Select Subject</h5>
    </div>
    <div class="modal-body">
        <div class="modal-info" id="create-subject-modal-body">
            <div class="exam-type-tabs">
                <div class="exam-post-inputbox subject-post-inputbox">
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-4" *ngFor="let subject of subjectData; let i=index">
                            <div class="custom-control custom-radio" data-toggle="tooltip" title="{{subject.section_name}}">
                                <input type="radio" id="radio_subject_{{i}}" class="custom-control-input" [(ngModel)]="selectedSubject" value={{subject.id}}>
                                <label class="custom-control-label " for="radio_subject_{{i}}"> {{subject.section_name}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="alert alert-danger cust-err-msg" id="error-msg-subject" style="display:none;">
                  Please select atleast one <strong>Subject!</strong>
               </div>
                <div class="row mt-3">
                    <div class="col-12 text-right">
                        <button class="btn btn-previous mr-2" data-dismiss="modal" data-target="#create-post" (click)="open('section2')" data-toggle="modal">Previous</button>
                        <button class="btn btn-pink-gradiant btn-next" data-dismiss="modal" data-target="#select-subject-post" (click)="open('submit')" data-toggle="modal" [disabled]="isSubmit">Submit</button>
                    </div>
                </div>

            </div>

        </div>
        <!-- BODY Of POPUP ENDS -->
    </div>
</div>

</div>
